import { withOidcSecure } from "@axa-fr/react-oidc";
import HomeLayout from "components/Layout/HomeLayout";
import React, { useEffect, useState } from 'react'
import DepositMoneyForm from "./DepositMoneyForm";
import { useDispatch, useSelector } from "react-redux";
import HomeHeader from "components/CustomComponents/HomeHeader";
import { useTranslation } from "react-i18next";
import { set } from "react-hook-form";
import DepositMoneyConfirm from "./DepositMoneyConfirm";
import Modal from "components/CustomComponents/Modal";
import SuccessDeposit from "./SuccessDeposit";
import CustomAlertModel from "components/CustomComponents/CustomAlertModel";
import { useNavigate } from "react-router";
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';







const DepositFunds = () => {
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_secured_credit_add_funds'));

    const HeadingStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[var(--modal-text-highlight)]";

    
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const navigate = useNavigate();


    const [isNext, setIsNext] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [transferMoneyConfirmDisplayData, setTransferMoneyConfirmDisplayData] = useState(null)
    const [depositFundPayload, setDepositFundPayload] = useState(null)
    const [fundTransferStatus, setFundTransferStatus] = useState("");

    const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
    const transferAccounts = useSelector(state => state.transferAccounts);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [show2faSelection, setshow2faSelection] = useState(false);
    const [otpGenerationType, setOtpGenerationType] = useState(false);
    const [fromAccount, setFromAccount] = useState('');
    const [depositFundErrorMsg, setDepositFundErrorMsg] = useState('');
    const [isSuccessfullTransferModalOpen, setIsSuccessfullTransferModalOpen] = useState(false);
    const [isShowCancelButton, setIsShowCancelButton] = useState(false);

    const [showModel, setShowModel] = useState(false);
    const [highlightMsg, setHighlightMsg] = useState('');
    const [headerMsg, setheaderMsg] = useState('');
    const [subHeaderMsg, setSubHeaderMsg] = useState('');
    const [btn1Exists, setBtn1Exists] = useState(false);
    const [btn2Exists, setBtn2Exists] = useState(false);
    const [btn1Text, setBtn1Text] = useState('');
    const [btn2Text, setBtn2Text] = useState('');
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
    const [modelImage, setModelImage] = useState('');
    const [footerMsg, setFooterMsg] = useState('');
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(false);
    const [btn1TextColor, setBtn1TextColor] = useState('');
    const [btn1BgColor, setBtn1BgColor] = useState('');
    const [btn2Focus, setBtn2Focus] = useState(false);

    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = " text-[var(--modal-text-heading-clr)] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-normal cursor-pointer pointer-events-none  text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgPlusStyles = "font-hanken-grotesk modal-title md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-normal cursor-pointer pointer-events-none text-white";
    const footerMsgstyles = "font-hanken-grotesk modal-title lg:text-[14px] md:text-[13px] sm:text-[13px] text-[14px] font-normal cursor-pointer pointer-events-none";


    const setIsNextFun = (value) => {
        setIsNext(value);
    }

    const setConfirmDisplayDataFun = (array) => {
        setTransferMoneyConfirmDisplayData(array)
    }
    const setDepositFundPayloadFun = (obj) => {
        setDepositFundPayload(obj)
    }

    const setFundTransferStatusFun = (value, fromAccount) => {
        setFundTransferStatus(value)
        setFromAccount(fromAccount);
    }

    const setDepositFundErrorMsgFun = (errMsg, fromAccount) => {
        setDepositFundErrorMsg(errMsg);
        setFromAccount(fromAccount);
    }

    const openSuccessfullTransferModal = () => {
        console.log("open success modal")
        setIsShowCancelButton(false)
        setIsSuccessfullTransferModalOpen(true);
    };
    useDocumentTitle(t('page_title_secured_credit_add_funds'));

    useEffect(() => {
        switch (fundTransferStatus) {

            case "success":
                openSuccessfullTransferModal();
                break;
            case "error":
                openErrorTransferModal();
                break;
        }
        dispatch({ type: "RESET_SECURE_CREDIT_DEPOSIT_MONEY_PAYLOAD" })
    }, [fundTransferStatus])

    const closeSuccessfullTransferModal = () => {
        onCompletion();
        setIsSuccessfullTransferModalOpen(false);

    };

    const onCompletion = () => {
        setIsNext(false);
        setFundTransferStatus("");
    }

    const openErrorTransferModal = () => {
        // setIsErrorTransferModalOpen(true);
        setIsLoading(false)
        showAlertModal(
            true,
            <p className="sm:flex block flex-col">
                {t("oops_exclamation")}
                <span className="text-[var(--transferSubHeading-text)]"> {depositFundErrorMsg}</span>
            </p>,
            '',
            'Please try again later',
            true,
            false,
            'Home',
            '',
            true,
            kudzuPlusTrue
                ? require('../../../assets/kudzu-plus-images/transfer-error.png')
                : require('../../../assets/images/transfer-error.png')
        );
    };

    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, showErrorImg, isBorderNone, btn1TextColor, btn1BgColor) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setFooterMsg(footerMsg)
        setBtn1TextColor(btn1TextColor)
        setBtn1BgColor(btn1BgColor)
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
    }

    const closeCustomAlertModal = () => {
        setShowModel(false);
        navigate(`/home`);

    }

    const onAcptBtnClick = () => {
        closeCustomAlertModal();
    }

    const onCancelBtnClick = () => {
        closeCustomAlertModal();
    }

    useEffect(() => {
           window.scrollTo(0, 0);
        }, [isNext])

    return (
        <>
            <HomeLayout>


                <HomeHeader heading={t("TRANSFER_FUNDS_TO")} isHeaderCaption={true} />
                <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] 
      animate__animated animate__fadeInRight '>

                    {
                        isNext ?
                            <DepositMoneyConfirm
                                datas={transferMoneyConfirmDisplayData}
                                depositFundPayload={depositFundPayload}
                                onSetStatus={setFundTransferStatusFun}
                                onSetErrorMsg={setDepositFundErrorMsgFun}
                                onCancelSelect={setIsNextFun}

                            />
                            :
                            <DepositMoneyForm
                                onNextSelect={setIsNextFun}
                                onConfirmDisplayData={setConfirmDisplayDataFun}
                                onDepositFundPayload={setDepositFundPayloadFun}
                            />
                    }

                </div>
            </HomeLayout>
            <Modal
                isOpen={isSuccessfullTransferModalOpen}
                onClose={closeSuccessfullTransferModal}
                alignItems="items-center"
                title={
                    <div className="w-full relative">
                        {/* close icon location should be controlled in Modal header ideally */}
                        <p className={`${HeadingStyles} text-left`}>
                            <span className="text-[#2965FB]">{t("DONE")}!</span>
                            <br />
                            <span className="text-[var(--modal-text-heading-clr)]">
                                {t("DEPOSIT_FUNDS_SUCCESS_SUBHEADING")}
                            </span>
                        </p>
                    </div>
                }
                content={
                    <div className="w-full">
                        <SuccessDeposit onClose={closeSuccessfullTransferModal} />
                    </div>
                }
            />

            <CustomAlertModel isOpen={showModel}
                onClose={closeCustomAlertModal}
                image={modelImage}
                // highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                // HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                // subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                    <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={footerMsgstyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                isBorderNone={false}
                showErrorImg={showErrorImg}
                btn2Focus={btn2Focus}
                btn1BgColor={btn1BgColor}
                btn1TextColor={btn1TextColor}
            />
        </>

    );
}
export default withOidcSecure(DepositFunds) 